namespace RioERP.Reports {
    export interface ScanBookRequest extends Serenity.ServiceRequest {
        BookIsbn?: string;
        OrderId?: number;
    }
}
